export default __webpack_public_path__ + "static/media/emptys.f18fe705.svg";